<div class="col-md-12">
    <div class="container-fluid">
        <div class="row text-center mt-2">
            <div class="col-4"></div>
            <div class="col-md-3">
                <img src="./../../../assets/images/logo.svg" class="img-fluid" alt="" height="100">
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</div>

<div class="row">
  
</div>